"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _common = require("../utils/common");
var _logger = _interopRequireDefault(require("../utils/logger"));
var _menu = require("../utils/menu");
var _type = require("../utils/type");
var _topologicalSort = _interopRequireDefault(require("../utils/topological-sort"));
var _module = _interopRequireDefault(require("./module"));
var _replaceUrl = _interopRequireDefault(require("../utils/replace-url"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-param-reassign, no-underscore-dangle */
/**
 * 本地hmr的管理对象
 */
var ModuleManage = /*#__PURE__*/function () {
  function ModuleManage(_ref, allWebpackExternals) {
    var baseComp = _ref.baseComp;
    (0, _classCallCheck2["default"])(this, ModuleManage);
    // 无极组件商店的db信息
    this.compDBList = [];
    this.compDBMap = null;
    // 无极组件的单一实例缓存池
    // 唯一实例必须帮忙标记，后续要做判断
    var Base = baseComp.Base;
    Base.__uuid__ = (0, _common.generateUUID)();
    this.installedModules = {
      // 组件基类(业务需要解构，运行时继承)
      base: {
        compInfo: baseComp
      }
    };
    // eslint-disable-next-line
    window.__installedModules__ = this.installedModules;
    // 所有公共的外部依赖，比如vue、antd、echart等
    this.allWebpackExternals = allWebpackExternals;
    this.hmrUrlObj = {};

    /**
     * 必须加载的组件
     * 在这个列表中，即使被标记为懒加载的组件，也要提前加载
     */
    this.forceLoadComponents = [];

    /**
     * 懒加载的组件
     * 在这个列表中，必定会被懒加载
     */
    this.lazyLoadComponents = [];

    // 可以通过插件的方式注入加载module的逻辑
    this.moduleLoadPlugins = [];

    // 需要加载的ui库
    this.library = '';

    // 如果用了直出要忽略一些报错
    this.ignoreInstalledModulesNotMatchError = false;
    this.staticFileHost = {};
  }

  /**
   * @typedef {Object} CompKeysOptions 加载组件列表的配置项
   * @property {boolean} editor 是否是编辑时
   * @property {string[]} forceLoadComponents 强制加载的组件
   * @property {string[]} lazyLoadComponents 通过配置项声明要求懒加载的组件，这个的优先级比forceLoadComponents高
   * @property {boolean} lazyLoadRestOfAllComponents 在有compKeys时 懒加载剩下的全量组件
   * @property {library} library 本次需要使用的ui库
   */

  /**
   * 暴露给外部调用的获取按需组件集，不传则db全量
   * @param {*} compKeys 组件key集
   * @param {CompKeysOptions} opts 配置项
   * @param {*} dependencies 依赖
   */
  return (0, _createClass2["default"])(ModuleManage, [{
    key: "initCompsByCompKeys",
    value: (function () {
      var _initCompsByCompKeys = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(compKeys, opts, dependencies) {
        var _this = this;
        var lazyLoad;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.forceLoadComponents = (opts === null || opts === void 0 ? void 0 : opts.forceLoadComponents) || [];
              this.lazyLoadComponents = (opts === null || opts === void 0 ? void 0 : opts.lazyLoadComponents) || [];
              this.library = (opts === null || opts === void 0 ? void 0 : opts.library) || this.library;
              this.buildCompDBMap();
              lazyLoad = !Boolean(compKeys);
              _logger["default"].debug('[initCompsByCompKeys] args', compKeys, opts, dependencies);
              compKeys = this.getComponentKeysToLoad(compKeys, opts, dependencies);

              // 确保要获取的无极组件集 + 所有的依赖集，全部下载完毕
              _context.next = 9;
              return this.initCompModulesByCompKeys(compKeys, lazyLoad);
            case 9:
              _context.next = 11;
              return (0, _common.allSettled)(Object.keys(this.installedModules).map(function (compKey) {
                var curModule = _this.installedModules[compKey];
                if (!curModule.loadPromise) return Promise.resolve();
                return curModule.loadPromise;
              }));
            case 11:
              // 在实例化组件之前，进行拓扑排序，防止依赖加载晚了
              compKeys = (0, _topologicalSort["default"])(compKeys, this);
              _logger["default"].debug('[initCompsByCompKeys] topologicalSort', compKeys);
              this.initLazyLoadModuleComponentInstance(compKeys);

              // 将组件逐个实例化，并返回
              return _context.abrupt("return", this.instantiateComponents(compKeys));
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initCompsByCompKeys(_x, _x2, _x3) {
        return _initCompsByCompKeys.apply(this, arguments);
      }
      return initCompsByCompKeys;
    }())
  }, {
    key: "setCompDBList",
    value: function setCompDBList(DBList) {
      this.compDBList = DBList;
    }

    /**
     * @typedef {Object} StaticFileHost
     * @property {string} host
     * @property {boolean} shuffle 是否有要轮流替换，如果为 true，会将一半的请求改为提供的 host
     */
    /**
     * 设置静态资源的 host
     * @param {*} registry
     * @param {*} group
     * @param {string|StaticFileHost} prefix
     * @returns
     */
  }, {
    key: "setStaticFileHost",
    value: function setStaticFileHost(registry, group, prefix) {
      if (!prefix) return;
      if (typeof prefix === 'string') {
        this.staticFileHost["".concat(registry, "/").concat(group)] = prefix.replace(/https?:\/\//, '');
        return;
      }
      this.staticFileHost["".concat(registry, "/").concat(group)] = {
        host: prefix.host.replace(/https?:\/\//, ''),
        shuffle: prefix.shuffle
      };
    }
  }, {
    key: "getStaticFile",
    value: function getStaticFile(url, module) {
      if (!module.compDB) return url;
      var _module$compDB = module.compDB,
        registry = _module$compDB.registry,
        group = _module$compDB.group;
      var host = this.staticFileHost["".concat(registry, "/").concat(group || '')];
      if (!host) return url;
      return (0, _replaceUrl["default"])(url, host);
    }
  }, {
    key: "setDefaultLibrary",
    value: function setDefaultLibrary(library) {
      this.library = library;
    }
  }, {
    key: "registerModuleLoader",
    value: function registerModuleLoader(type, loader) {
      this.moduleLoadPlugins.push({
        type: type,
        loader: loader
      });
    }
  }, {
    key: "buildCompDBMap",
    value: function buildCompDBMap() {
      if (this.compDBMap) return;
      var map = {};
      this.compDBList.forEach(function (comp) {
        map[comp.id] = comp;
      });
      this.compDBMap = map;
    }
  }, {
    key: "gatherDep",
    value: function gatherDep(key) {
      var _compInfo$extraInfo;
      var deps = new Set();
      var compInfo = this.compDBMap[key];
      if (compInfo !== null && compInfo !== void 0 && compInfo.dependencies) {
        compInfo.dependencies.forEach(function (dep) {
          deps.add(dep);
        });
      }
      // 在线组件会把依赖放在extraInfo里
      if (compInfo !== null && compInfo !== void 0 && (_compInfo$extraInfo = compInfo.extraInfo) !== null && _compInfo$extraInfo !== void 0 && _compInfo$extraInfo.compDependencies) {
        compInfo.extraInfo.compDependencies.filter(function (i) {
          return i.startsWith('public') || i.startsWith('local');
        }) // 不需要ui-core或者xy-client处理内置组件
        .forEach(function (dep) {
          deps.add(dep);
        });
      }
      return deps;
    }

    // 获取本次需要实例化的组件key
  }, {
    key: "getComponentKeysToLoad",
    value: function getComponentKeysToLoad(compKeys, opts, dependencies) {
      var _this2 = this;
      if (compKeys) {
        // 运行时走这里
        // 特殊逻辑 除了页面已有的组件 其他的组件全量懒加载 用于页面中内嵌编辑时
        if (opts !== null && opts !== void 0 && opts.lazyLoadRestOfAllComponents) {
          var allCompKeys = this.getCompKeysByOpts(opts);
          var needLazyLoadComps = new Set(allCompKeys);
          // 去掉指定同步加载的
          compKeys.forEach(function (key) {
            needLazyLoadComps["delete"](key);

            // 依赖也需要同步加载
            var deps = _this2.gatherDep(key);
            deps.forEach(function (dep) {
              needLazyLoadComps["delete"](dep);
            });
          });

          // 补充懒加载列表
          this.lazyLoadComponents = [].concat((0, _toConsumableArray2["default"])(needLazyLoadComps), (0, _toConsumableArray2["default"])(this.lazyLoadComponents));
          // 加载列表替换为全量
          compKeys = allCompKeys;
          _logger["default"].debug('[initCompsByCompKeys] lazyLoadRestOfAllComponents', compKeys, this.lazyLoadComponents);
        } else {
          // 对于普通的场景，我们在实际下载之前，就把依赖收集好
          var compKeysWithDeps = new Set();
          compKeys.forEach(function (key) {
            compKeysWithDeps.add(key);
            var deps = _this2.gatherDep(key);
            deps.forEach(function (dep) {
              compKeysWithDeps.add(dep);
            });
          });
          compKeys = Array.from(compKeysWithDeps);
          _logger["default"].debug('[initCompsByCompKeys] loadWithDependencies', compKeys);
        }
        // 过滤 db 不存在的组件
        var compDBIds = this.compDBList.map(function (comp) {
          return comp.id;
        });
        compKeys = compKeys.filter(function (key) {
          return compDBIds.includes(key);
        });
        // 用户提供了组件key, 这种情况不要懒加载
      } else {
        // 编辑时走到这里 全量加载并且懒加载某些组件
        // 根据配置项获取组件列表
        compKeys = this.getCompKeysByOpts(opts);
      }
      var dependComponents = this.getSpecialDepsComponents(dependencies);
      // 注入特殊依赖的组件
      compKeys = (0, _toConsumableArray2["default"])(new Set([].concat((0, _toConsumableArray2["default"])(compKeys), (0, _toConsumableArray2["default"])(dependComponents))));

      // 注入hmr组件
      compKeys = (0, _toConsumableArray2["default"])(new Set([].concat((0, _toConsumableArray2["default"])(compKeys), (0, _toConsumableArray2["default"])(Object.keys(this.hmrUrlObj)))));
      return compKeys;
    }
  }, {
    key: "instantiateComponents",
    value: function instantiateComponents(compKeys) {
      var _this3 = this;
      // 从单一实例缓存池提取并返回
      var resultObj = {};
      compKeys.forEach(function (compKey) {
        var _curModule$compDB;
        var curModule = _this3.installedModules[compKey];
        var compInfo = curModule.compInfo;
        // 有可能执行失败，返回空；这里只取实例化成功的
        if (!compInfo) return;
        resultObj[compKey] = curModule;
        if (!curModule.compDB) return;
        // 将deprecated的组件进行隐藏
        if ((_curModule$compDB = curModule.compDB) !== null && _curModule$compDB !== void 0 && _curModule$compDB.deprecated) {
          _this3.setModuleVisible(curModule, false);
          return;
        }
        // 非当前框架的组件进行隐藏
        if (curModule.compDB.library && curModule.compDB.library !== _this3.library) {
          _this3.setModuleVisible(curModule, false);
        }
      });
      return resultObj;
    }
  }, {
    key: "setModuleVisible",
    value: function setModuleVisible(module, visible) {
      if (!module.compDB) return;
      var compInfo = module.compInfo;

      // 如果在compDB中声明了不可见的组件，那么永远不可见
      var computedVisible = module.compDB.visible ? visible : false;
      module.compDB.visible = computedVisible;
      module.setCompInfo(_objectSpread(_objectSpread({}, compInfo), {}, {
        config: _objectSpread(_objectSpread({}, compInfo.config), {}, {
          visible: computedVisible,
          fitData: computedVisible ? compInfo.fitData : function () {
            return null;
          }
        })
      }));
    }

    /**
     * 给予懒加载模块一个异步函数作为组件实例
     */
  }, {
    key: "initLazyLoadModuleComponentInstance",
    value: function initLazyLoadModuleComponentInstance(compKey) {
      var _this4 = this;
      var traverseKey = compKey || Object.keys(this.installedModules);
      traverseKey.forEach(function (key) {
        var curModule = _this4.installedModules[key];
        if (!curModule) {
          _logger["default"].error("%c wujiComp component[".concat(key, "] does not exist!"), 'color: red;');
        }
        if (curModule.lazyLoad) {
          var compInfo = curModule.compInfo;
          // 懒加载函数有可能执行失败，返回空；这里只取实例化成功的
          if (compInfo) {
            // 如果是懒加载的组件，我们生成一个异步函数作为组件实例
            curModule.setCompInfo({
              config: compInfo.config,
              comp: _this4.getLazyLoadCompInstance(key)
            });
          }
        }
      });
    }

    /**
     * 加载那些特殊的依赖组件
     * 这些组件并未在组件打包的时候被声明
     * @param {*} dependencies
     * @returns
     */
  }, {
    key: "getSpecialDepsComponents",
    value: function getSpecialDepsComponents(dependencies) {
      var dependComponents = [];
      if (dependencies) {
        var categories = dependencies.categories,
          groupList = dependencies.groupList;
        if (categories) {
          dependComponents = this.compDBList.filter(function (comp) {
            var id = comp.category.id;
            // 只加载指定的分类以及对应的商店
            // 如果没有指定groupList，只加载默认的商店
            var passGroupListRule = groupList ? groupList.includes(comp.group) : !comp.group;
            return categories.includes(id) && passGroupListRule;
          }).map(function (comp) {
            return comp.id;
          });
        }
      }
      return dependComponents;
    }

    /**
     * 懒加载的组件实例
     * @param {*} key
     * @returns
     */
  }, {
    key: "getLazyLoadCompInstance",
    value: function getLazyLoadCompInstance(key) {
      var _this5 = this;
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var curModule, _compInfo, compInfo;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              curModule = _this5.installedModules[key]; // module被改变了，但是这个函数有可能被某些代码调用
              // 为了不要反复的触发下载，如果module已经被标记为非懒加载了，我们不要重新加载
              if (curModule.lazyLoad) {
                _context2.next = 6;
                break;
              }
              _context2.next = 4;
              return curModule.loadPromise;
            case 4:
              _compInfo = curModule.compInfo;
              return _context2.abrupt("return", _compInfo.comp);
            case 6:
              _logger["default"].debug('[getLazyLoadCompInstance]', key);
              curModule.loadPromise = _this5.loadCompModule(curModule, {
                lazyLoad: false
              }).then(function () {
                // 重置compInfo，让下次获取CompInfo的时候执行正常组件的js
                curModule.setCompInfo(null);
              });
              _context2.next = 10;
              return curModule.loadPromise;
            case 10:
              compInfo = curModule.compInfo;
              return _context2.abrupt("return", compInfo.comp);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }

    /**
     * 下载所有HMR组件
     * @returns
     */
  }, {
    key: "initHMRComponents",
    value: (function () {
      var _initHMRComponents = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this6 = this;
        var compKeys, resultObj;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              compKeys = (0, _toConsumableArray2["default"])(Object.keys(this.hmrUrlObj));
              _context3.next = 3;
              return this.initCompModulesByCompKeys(compKeys);
            case 3:
              resultObj = {};
              compKeys.forEach(function (compKey) {
                resultObj[compKey] = _this6.getComponentInfo(compKey);
              });
              return _context3.abrupt("return", resultObj);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initHMRComponents() {
        return _initHMRComponents.apply(this, arguments);
      }
      return initHMRComponents;
    }())
  }, {
    key: "getComponentInfo",
    value: function getComponentInfo(compKey) {
      var curModule = this.installedModules[compKey];
      if (!curModule) {
        _logger["default"].error("%c wujiComp component[".concat(compKey, "] does not exist!"), 'color: red;');
      } else {
        var compInfo = this.installedModules[compKey].compInfo;
        // 懒执行函数有可能执行失败，返回空；这里只取实例化成功的
        if (compInfo) {
          return this.installedModules[compKey];
        }
      }
    }

    /**
     * 根据配置项获取需要加载的组件列表
     * @param {CompKeysOptions} opts
     */
  }, {
    key: "getCompKeysByOpts",
    value: function getCompKeysByOpts(opts) {
      var _this7 = this;
      var _opts$editor = opts.editor,
        editor = _opts$editor === void 0 ? false : _opts$editor;
      return this.compDBList.filter(function (comp) {
        // 如果没有指定拉取编辑时组件，且这个组件有标记是编辑时专用的，不加载
        if (!editor && comp.editorOnly) return false;
        if (comp.deprecated) {
          return _this7.forceLoadComponents.includes(comp.id);
        }
        return true;
      }).map(function (compDB) {
        return compDB.id;
      });
    }

    /**
     * 批量的初始化组件单一实例集：按需的组件key集合
     * @param {*} compKeys 按需的组件key集合
     * @param {boolean} lazyLoad
     */
  }, {
    key: "initCompModulesByCompKeys",
    value: (function () {
      var _initCompModulesByCompKeys = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(compKeys) {
        var _this8 = this;
        var lazyLoad,
          allPromises,
          _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              lazyLoad = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;
              allPromises = []; // 收集组件keys对应的
              compKeys.forEach(function (compKey) {
                // 还未在installedModules实例池的，才会从组件商店的db信息开始初始化
                if (!_this8.installedModules[compKey]) {
                  _this8.initCompModule(compKey, lazyLoad);
                } else if (_this8.installedModules[compKey].lazyLoad && !lazyLoad) {
                  // 对于已经在installedModules实例池的，检查是是否是懒加载
                  // 如果配置项要求非懒加载，那么就要重新初始化
                  _logger["default"].debug('[initCompModulesByCompKeys] reinit lazyload component', compKey);
                  _this8.initCompModule(compKey, lazyLoad);
                }
                allPromises.push(_this8.installedModules[compKey].loadPromise || Promise.resolve());
              });
              _context4.next = 5;
              return (0, _common.allSettled)(allPromises);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function initCompModulesByCompKeys(_x4) {
        return _initCompModulesByCompKeys.apply(this, arguments);
      }
      return initCompModulesByCompKeys;
    }()
    /**
     * 初始化某个组件
     * @param {*} compKey
     * @param {boolean} lazyLoad
     * @returns
     */
    )
  }, {
    key: "initCompModule",
    value: function initCompModule(compKey) {
      var lazyLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var curModule = new _module["default"](compKey, this.installedModules.base, this.allWebpackExternals);
      curModule.lazyLoad = lazyLoad;
      this.installedModules[compKey] = curModule;
      _logger["default"].debug('[initCompModule]', compKey, lazyLoad);

      // 若是hmr的组件，就不需要考虑组件商店是否存在了
      if (this.hmrUrlObj && this.hmrUrlObj[compKey]) {
        // 标记为组件为loading状态：ModuleStatus.LOADING
        curModule.compDB = {
          id: compKey,
          src: this.hmrUrlObj[compKey]
        };
        curModule.isHmr = true;
        curModule.loadPromise = this.loadCompModule(curModule, {
          lazyLoad: false
        });
        return curModule;
      }

      // 获取组件商店对应的cos地址，下载实例化
      var compDB = this.compDBList.find(function (item) {
        return item.id === compKey;
      });
      if (!compDB) {
        // 标记为组件不存在 + 控制台抛错
        curModule.setErrorStatus(_menu.ErrorStatus.DB);
      } else {
        // 标记为组件为loading状态：ModuleStatus.LOADING
        curModule.compDB = compDB;
        curModule.loadPromise = this.loadCompModule(curModule, {
          lazyLoad: lazyLoad
        });
      }
      return curModule;
    }

    /**
     * 基于组件商店的db cos地址，异步下载并注册对应的无极组件
     * @param {*} module
     * @param {*} opts
     * @param {boolean} opts.lazyload
     */
  }, {
    key: "loadCompModule",
    value: (function () {
      var _loadCompModule = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(module) {
        var opts,
          extraInfo,
          type,
          loader,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              opts = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {
                lazyLoad: true
              };
              module.status = _menu.ModuleStatus.LOADING;
              extraInfo = module.compDB.extraInfo;
              if (!(0, _type.isObject)(extraInfo)) {
                _context5.next = 20;
                break;
              }
              type = extraInfo.type;
              loader = this.getLoader(type); // 如果没有对应的loader，加载失败
              if (loader) {
                _context5.next = 10;
                break;
              }
              module.setErrorStatus(_menu.ErrorStatus.UNKNOWN_LOADER);
              _logger["default"].error("%c wujiComp component[".concat(module.compDB.id, "] instantiation failed!"), 'color: red;', "It specifies an unknown loader ".concat(type, "!"));
              return _context5.abrupt("return");
            case 10:
              _context5.prev = 10;
              _context5.next = 13;
              return loader(module, opts, extraInfo);
            case 13:
              _context5.next = 19;
              break;
            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](10);
              module.setErrorStatus(_menu.ErrorStatus.LOAD_FAIL);
              _logger["default"].error("%c wujiComp component[".concat(module.compDB.id, "] instantiation failed!"), 'color: red;', 'load failed!', _context5.t0);
            case 19:
              return _context5.abrupt("return");
            case 20:
              _context5.next = 22;
              return this.defaultModuleLoader(module, opts);
            case 22:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[10, 15]]);
      }));
      function loadCompModule(_x5) {
        return _loadCompModule.apply(this, arguments);
      }
      return loadCompModule;
    }())
  }, {
    key: "getLoader",
    value: function getLoader(type) {
      var plugin = this.moduleLoadPlugins.find(function (plugin) {
        return plugin.type === type;
      });
      return plugin === null || plugin === void 0 ? void 0 : plugin.loader;
    }
  }, {
    key: "defaultModuleLoader",
    value: function () {
      var _defaultModuleLoader = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(module, opts) {
        var _this9 = this;
        var _module$compDB2, _module$compDB3, _module$compDB4, lazyLoad, script;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              // 确保有componentJS才能实现懒加载
              lazyLoad = this.isLazyLoad(module, opts) && ((_module$compDB2 = module.compDB) === null || _module$compDB2 === void 0 ? void 0 : _module$compDB2.componentJsSrc); // 如果是懒加载，那么只加载组件的配置文件
              script = lazyLoad ? this.getStaticFile((_module$compDB3 = module.compDB) === null || _module$compDB3 === void 0 ? void 0 : _module$compDB3.componentJsSrc, module) : this.getStaticFile((_module$compDB4 = module.compDB) === null || _module$compDB4 === void 0 ? void 0 : _module$compDB4.src, module);
              module.lazyLoad = lazyLoad;
              _logger["default"].debug('[defaultModuleLoader]', lazyLoad, script, module);
              _context7.next = 7;
              return (0, _common.loadScript)(script).then(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
                var compDependencies, dependencySet;
                return _regenerator["default"].wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      compDependencies = module.compDependencies;
                      if (!(module.webpackExternals.includes('React') && !_this9.allWebpackExternals.React)) {
                        _context6.next = 4;
                        break;
                      }
                      _context6.next = 4;
                      return _this9.loadReactDependencies();
                    case 4:
                      if (!(module.webpackExternals.includes('vue3') && !_this9.allWebpackExternals.vue3)) {
                        _context6.next = 7;
                        break;
                      }
                      _context6.next = 7;
                      return _this9.loadVue3Dependencies();
                    case 7:
                      if (!(module.status === _menu.ModuleStatus.LOADING)) {
                        _context6.next = 11;
                        break;
                      }
                      // 如果还是LOADING状态，说明组件源码的wujiComp.register调用注册失败
                      module.setErrorStatus(_menu.ErrorStatus.FILE);
                      _context6.next = 16;
                      break;
                    case 11:
                      if (!(compDependencies && compDependencies.length > 0)) {
                        _context6.next = 16;
                        break;
                      }
                      // 加载成功 + 有无极组件依赖的；则确认依赖的无极组件集是否都正常注册了(是递归哦)
                      // 如果模块本身是懒加载的，那么允许依赖的模块也是懒加载的
                      // 但是如果模块本身是非懒加载的，那么依赖的模块也必须是非懒加载的
                      if (!lazyLoad) {
                        dependencySet = new Set(compDependencies);
                        _this9.lazyLoadComponents = _this9.lazyLoadComponents.filter(function (i) {
                          return !dependencySet.has(i);
                        });
                      }
                      _logger["default"].debug('[defaultModuleLoader] loadDependencies', compDependencies, module.compKey, lazyLoad);
                      _context6.next = 16;
                      return _this9.initCompModulesByCompKeys(compDependencies, lazyLoad);
                    case 16:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              })));
            case 7:
              _context7.next = 12;
              break;
            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7["catch"](0);
              module.setErrorStatus(_menu.ErrorStatus.FILE);
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 9]]);
      }));
      function defaultModuleLoader(_x6, _x7) {
        return _defaultModuleLoader.apply(this, arguments);
      }
      return defaultModuleLoader;
    }()
  }, {
    key: "isLazyLoad",
    value: function isLazyLoad(module, opts) {
      var _module$compDB5, _module$compDB6, _module$compDB7, _module$compDB8;
      // 这两个配置的优先级最高
      if (this.lazyLoadComponents.includes((_module$compDB5 = module.compDB) === null || _module$compDB5 === void 0 ? void 0 : _module$compDB5.id)) {
        _logger["default"].debug('[isLazyLoad] hit lazyloadComponentArray', module.compDB.id);
        return true;
      }
      if (this.forceLoadComponents.includes((_module$compDB6 = module.compDB) === null || _module$compDB6 === void 0 ? void 0 : _module$compDB6.id)) {
        _logger["default"].debug('[isLazyLoad] hit forceLoadComponents', module.compDB.id);
        return false;
      }

      // 如果没有命中上面两个配置
      if (!opts.lazyLoad || !module.compDB.componentJsSrc) return false;

      // 非本次加载的组件库，都是用懒加载的方式加载
      // 之所以要在opts.lazyload判断之后，是为了防止运行时的组件被懒加载
      if ((_module$compDB7 = module.compDB) !== null && _module$compDB7 !== void 0 && _module$compDB7.library && ((_module$compDB8 = module.compDB) === null || _module$compDB8 === void 0 ? void 0 : _module$compDB8.library) !== this.library) return true;
      // 根据组件的compDB中的字段进行判断
      return module.compDB.lazyLoad || module.compDB.deprecated;
    }

    // --------------------------------------------------------------------------------
    /**
     * 暴露给cos文件的组件注册入口（类似amd requirejs的define定义）
     * @param {*} compKey 组件key
     * @param {*} compDependencies 无极组件的依赖
     * @param {*} webpackExternals 公共的外部依赖 -- webpack externals
     * @param {*} compFunc 懒执行的组件函数
     */
  }, {
    key: "register",
    value: function register(compKey, compDependencies, webpackExternals, compFunc) {
      if (!this.installedModules[compKey]) {
        if (this.ignoreInstalledModulesNotMatchError) {
          // 提前预下载了 这里没法区分出现了预期外的compKey是不是error
          return;
        }
        // 理论上所有的组件js下载，都会预先初始化Module对象；不存在的话只有一种可能：实际注册的key和实例化Module时创建的key不一致
        _logger["default"].error("%c wujiComp component[".concat(compKey, "] register failed[").concat(_menu.ErrorStatus.NOTMATCH, "]!"), 'color: red;');
        return;
      }
      var curModule = this.installedModules[compKey];
      curModule.init(compDependencies, webpackExternals, compFunc);
      this.installedModules[compKey] = curModule;
      _logger["default"].debug('[registerJS]', compKey);
    }
  }, {
    key: "registerComponentJS",
    value: function registerComponentJS(compKey, compDependencies, webpackExternals, compFunc) {
      var curModule = this.installedModules[compKey];
      if (!curModule.lazyLoad) return;
      this.register(compKey, compDependencies, webpackExternals, compFunc);
      _logger["default"].debug('[registerComponentJS]', compKey, curModule.lazyLoad);
    }

    /**
     * 预加载、懒执行模式：调用时的依赖链已全部下载完毕
     * 用于无极组件开发的依赖声明(基于原生写法的转换：import wInput from "@wuji/c/public/w-input")
     * @param {*} compKey
     */
  }, {
    key: "require",
    value: function require(compKey) {
      compKey = compKey.replace('@wuji/c/', '').replace(/\//g, '-');
      // 内部的逻辑实现理论上已保证调用这里时，所有的依赖预加载完成
      if (!this.installedModules[compKey]) {
        throw Error("wujiComp require component[".concat(compKey, "] does not exist!"));
      }
      _logger["default"].debug('[require]', compKey, this.installedModules[compKey]);
      var compInfo = this.installedModules[compKey].compInfo;
      return compInfo;
    }

    /**
     * 懒加载、懒执行模式：调用时的依赖链尚未下载(异步)
     * 用于无极组件开发的依赖声明(类似webpack的require.ensure异步写法：wujiComp.asyncRequire("@wuji/c/public/w-input"))
     * @param {*} compKey
     */
  }, {
    key: "asyncRequire",
    value: (function () {
      var _asyncRequire = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(compKey) {
        var compKeys, result, compResult;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              compKeys = [compKey];
              if (Array.isArray(compKey)) {
                compKeys = compKey;
              }
              compKeys = compKeys.map(function (key) {
                return key.replace('@wuji/c/', '').replace(/\//g, '-');
              });
              _context8.next = 5;
              return this.initCompsByCompKeys(compKeys);
            case 5:
              result = _context8.sent;
              if (result) {
                _context8.next = 8;
                break;
              }
              throw Error('wujiComp asyncRequire loading error!');
            case 8:
              compResult = compKeys.map(function (key) {
                if (result[key] && result[key].compInfo) {
                  return result[key].compInfo;
                }
                throw Error("wujiComp asyncRequire component[".concat(key, "] does not exist!"));
              });
              if (!Array.isArray(compKey)) {
                _context8.next = 11;
                break;
              }
              return _context8.abrupt("return", compResult);
            case 11:
              return _context8.abrupt("return", compResult[0]);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function asyncRequire(_x8) {
        return _asyncRequire.apply(this, arguments);
      }
      return asyncRequire;
    }())
  }, {
    key: "loadReactDependencies",
    value: function () {
      var _loadReactDependencies = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var _this10 = this;
        var deps, reactAdaptorComps;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(typeof this.allWebpackExternals.reactAdaptor === 'function')) {
                _context9.next = 5;
                break;
              }
              _context9.next = 3;
              return this.allWebpackExternals.reactAdaptor();
            case 3:
              deps = _context9.sent;
              Object.keys(deps).forEach(function (key) {
                if (_this10.allWebpackExternals[key]) return;
                _this10.allWebpackExternals[key] = deps[key];
              });
            case 5:
              reactAdaptorComps = this.allWebpackExternals.ReactAdaptor;
              Object.keys(reactAdaptorComps).forEach(function (key) {
                _this10.installedModules[key] = {
                  compInfo: reactAdaptorComps[key]
                };
              });
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function loadReactDependencies() {
        return _loadReactDependencies.apply(this, arguments);
      }
      return loadReactDependencies;
    }()
  }, {
    key: "loadVue3Dependencies",
    value: function () {
      var _loadVue3Dependencies = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        var _this11 = this;
        var deps;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(typeof this.allWebpackExternals.loadVue3Adaptor === 'function')) {
                _context10.next = 5;
                break;
              }
              _context10.next = 3;
              return this.allWebpackExternals.loadVue3Adaptor();
            case 3:
              deps = _context10.sent;
              Object.keys(deps).forEach(function (key) {
                if (_this11.allWebpackExternals[key]) return;
                _this11.allWebpackExternals[key] = deps[key];
              });
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function loadVue3Dependencies() {
        return _loadVue3Dependencies.apply(this, arguments);
      }
      return loadVue3Dependencies;
    }()
  }, {
    key: "setHmrUrlObj",
    value: function setHmrUrlObj(hmrUrlObj) {
      this.hmrUrlObj = hmrUrlObj;
    }
  }]);
}();
var _default = exports["default"] = ModuleManage;